import Button from "@mui/material/Button";

type ButtonProps = {
  variant: "text" | "contained" | "outlined";
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  fullWidth?: true | false;
  href?: string;
  onClick: (e?: any) => void;
  children: string;
  className?: string;
  type?: "button" | "submit";
  style?: any;
};

export default function ButtonComponent(props: ButtonProps) {
  return (
    <Button
      variant={props.variant}
      endIcon={props.endIcon}
      startIcon={props.startIcon}
      href={props.href}
      size={"small"}
      onClick={(e) => props.onClick(e)}
      type={props.type}
      className={props.className}
      style={props.style}
    >
      {props.children}
    </Button>
  );
}
